import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import CategoryFilter from './components/CategoryFilter';
import ToolCard from './components/ToolCard';
import { toolsData, categoryConfig, TOOL_CATEGORIES } from './config';
import {
  getToolsCollectionStructuredData,
  useSeoMetadata,
} from '../../utils/seo';
import styles from './index.module.scss';

const Tools = () => {
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState(TOOL_CATEGORIES.ALL);
  const currentLang = i18n.language?.startsWith('zh') ? 'zh' : 'en';

  const filteredTools = toolsData.filter(
    (tool) =>
      selectedCategory === TOOL_CATEGORIES.ALL || tool.category === selectedCategory
  );

  const categoryCounts = categoryConfig.reduce((acc, category) => {
    acc[category.key] =
      category.key === TOOL_CATEGORIES.ALL
        ? toolsData.length
        : toolsData.filter((tool) => tool.category === category.key).length;
    return acc;
  }, {});

  useSeoMetadata({
    title: currentLang === 'zh'
      ? 'P2T 工具市场 | 免费 AI、研究与效率工具合集'
      : 'P2T Tools Marketplace | Free AI, research, and productivity tools',
    description: currentLang === 'zh'
      ? '探索 P2T 工具市场：帧记 FrameMemo 截图识别笔记、HeadUp 屏幕保护与姿态提醒、Paper Trends 论文追踪、时间线可视化工具、免费大模型 API 观察站和 Codex 使用指南。'
      : 'Explore the P2T tools marketplace: FrameMemo screen-to-text notes, HeadUp screen privacy and posture reminders, Paper Trends research tracking, Timeline Visualizer, Free LLM API Radar, and Codex Guide.',
    path: '/tools',
    lang: currentLang,
    keywords: currentLang === 'zh'
      ? ['P2T 工具', '免费大模型 API', '论文追踪', 'Codex 使用指南', '时间线工具', 'macOS 姿态提醒']
      : ['P2T tools', 'free LLM API', 'research paper tracker', 'Codex guide', 'timeline visualizer', 'macOS posture reminder'],
    structuredData: getToolsCollectionStructuredData(toolsData, currentLang),
  });

  return (
    <div className={styles.toolsPage}>
      <Header />
      <div className={styles.backdrop} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>{t('tools.title')}</h1>
          <p className={styles.subtitle}>{t('tools.subtitle')}</p>
        </div>

        <CategoryFilter
          categories={categoryConfig}
          counts={categoryCounts}
          selected={selectedCategory}
          onChange={setSelectedCategory}
        />

        <div className={styles.toolsGrid} role="list">
          {filteredTools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Tools;
